<template>
    <div class="oiuh">
		<div class="rhjss" @click="applyApi=false;getCase()" v-if="applyApi">我的接口/<span>申请接口</span></div>
		<secret @orderId="getOrderId"></secret>
		<div class="bujss" v-if="!applyApi">
			<h6 class="joid">接口列表</h6>
			<div class="juidj">
				<!-- <el-input
					placeholder=""
					suffix-icon="el-icon-search"
					clearable
					v-model="input1"></el-input> -->
				<el-input placeholder="请输入接口名称" v-model="input1" clearable class="input-with-select">
				    <el-button slot="append" icon="el-icon-search" @click="getTable"></el-button>
				</el-input>
				<div @click="shenqing" class="rtgh">申请接口</div>
			</div>
			<div class="ryyh" :loading="tableLoading">
				<el-table
				    :data="tableData"
				    style="width: 100%">
				    <el-table-column
				      label="接口ID"
				      width="140">
					  <template slot-scope="scope">
						{{ scope.row.showId }}
					  </template>
				    </el-table-column>
				    <el-table-column
				      label="接口名称"
				      width="260">
				      <template slot-scope="scope">
						{{ scope.row.intfName }}
				      </template>
				    </el-table-column>
					<el-table-column
					  label="价格（元/次）"
					  width="140">
					  <template slot-scope="scope">
							{{ scope.row.intfPrice }}
					  </template>
					</el-table-column>
					<el-table-column
					  label="每分最大调用次数（次）"
					  width="180">
					  <template slot-scope="scope">
						{{ scope.row.maxInvokeCountPerMin }}
					  </template>
					</el-table-column>
				    <el-table-column label="操作" width="195">
				      <template slot-scope="scope">
				        <span class="bhuu" @click="handleEdit(scope.$index, scope.row)">测试接口</span>
				        <span class="bhussu" @click="handleDelete(scope.$index, scope.row)">删除</span>
				      </template>
				    </el-table-column>
				  </el-table>
				  
				  <div v-if="pages>10" class="erfr">
				  	<el-pagination
				  		background	
				  		:current-page="currentPage"
				  	    layout="prev, pager, next"
				  		@current-change="handleCurrentChange"
				  	    :total="pages">
				  	  </el-pagination>
				  </div>
				  <div v-if="tableData.length===0" class="njiis">
  <img src="../../../assets/kong/kong.png" alt=""/>
					  <p>{{ifSearch?'暂无搜索结果':'暂未申请接口'}}</p>
				  </div>
			</div>
		</div>
		
		<div v-if="applyApi" class="fghhs">
			<h6 class="joid">申请接口</h6>
			<div class="rhhjs">
				<div class="hsss">
					<el-input
					    placeholder="请输入接口名称"
						clearable
					    v-model="searchData">
					    <i @click="goSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
					  </el-input>
					  <el-tree
						v-if="treeData.length>0"
					    :data="treeData"
					    show-checkbox
						empty-text="暂无搜索结果"
					    node-key="id"
						ref="tree"
						@check-change="getCheckedKeys"
					    :default-expanded-keys="[1]">
					  </el-tree>
					  <!-- <div class="buttons">
					    <el-button @click="getCheckedNodes">通过 node 获取</el-button>
					    <el-button @click="getCheckedKeys">通过 key 获取</el-button>
					    <el-button @click="setCheckedNodes">通过 node 设置</el-button>
					    <el-button @click="setCheckedKeys">通过 key 设置</el-button>
					    <el-button @click="resetChecked">清空</el-button>
					  </div> -->
				</div>
				<div class="dfgg">
					<div class="ghuss">
						<p>已选接口 <span>{{chooseArr.length}}</span></p>
						<div class="fgss">
							<button class="one" @click="apply">立即申请</button>
							<button class="two" @click="resetChecked">全部删除</button>
						</div>
					</div>
					<div class="yius">
						<el-tag v-for="(item,index) in chooseArr" :key="item.id" size="big" @close="handleClose(index)" closable>{{item.label}}</el-tag>
						<!-- <span v-for="(item,index) in chooseArr" :key="item.id" > -->
							<!-- <el-tag v-if="item.children" v-for=" demo in item.children" size="big" @close="handleClose(demo.id)" closable>{{demo.label}}</el-tag> -->
							
						<!-- </span> -->
					</div>
				</div>
			</div>
		</div>
		
        <router-view></router-view>
    </div>
</template>
<script>
import secret from '../../../components/secret.vue'
import { orderApi } from '@/api'
export default {
    namme:'case3',
	components:{
	  secret
	},
    data(){
        return{
			input1: '',
			searchData: '',
			tableLoading: false,
			applyApi: false,
			tableData: [],
			orderId: '',
			treeData: [],
			chooseArr: [],
			chooseArrKeys: [],
			pages: 0,
			currentPage: 1,
			ifSearch: false,
			chooseLength: 0
        }
    },
    methods:{
	  getCheckedNodes() {
		console.log(this.$refs.tree.getCheckedNodes());
	  },
	  getCheckedKeys() {
		let arr01 = this.$refs.tree.getCheckedNodes()
		let resArr = []
		let len = arr01.length
		arr01.forEach(item =>{
			if (item.children) {
				len = len-1
			} else {
				resArr.push(item)
			}
		})
		// this.chooseLength = len
		this.chooseArr = resArr
		this.chooseArrKeys = this.$refs.tree.getCheckedKeys()
	  },
	  getOrderId(val) {
	  	if(!val) return
	  	this.orderId = val
	  	this.getCase()
		this.getSelects()
		if (this.$route.query.from==='detail') {
			this.applyApi = true
		}
	  },
	  getTable() {
		  this.ifSearch = true
		  this.getCase()
	  },
	  handleCurrentChange(val) {
	  	this.getCase(val)
	  },
	  getCase:function(page){
	      let params = {
	  		  userId: this.$cookies.getJSON('user').userId,
	  		  orderId: this.orderId,
			  name: this.input1,
			  pageNum: page || 1
	  	  }
		  this.tableLoading = true
	      orderApi.getOrderInterfaces(params)
	  	  .then((res) =>{
	  		  console.log(res)
	  		  if (res.state===200) {
	  			
	  		  } else {
	  			this.$message.error(res.message);
	  		  }
	  		  try{
	  		  	this.tableData = res.data.records
				this.pages = res.data.total
	  		  }catch(e){
	  		  	//TODO handle the exception
	  		  }
			  this.tableLoading = false
	  	  })
	  	  .catch(err=>{
			  this.tableLoading = false
	  		  alert(err);
	  	  })
	  },
	  handleClose(index) {
		this.$confirm('确定删除选中的接口吗',{type: 'warning'})
		  .then(_ => {
			// console.log(JSON.stringify(this.chooseArr))
			// this.chooseArr.forEach((item,index)=>{
			// 	if (item.id === id) {
					
			// 	}
			// })
			// console.log(JSON.stringify(this.chooseArr))
			this.chooseArr.splice(index, 1);
			let _this = this
			this.$refs.tree.setCheckedNodes(_this.chooseArr)
			done();
		  })
		  .catch(_ => {});
	  },
	  resetChecked() {
		  if (this.chooseArr.length===0) return
		  this.$confirm('确定清除全部选择的接口吗',{type: 'warning'})
		    .then(_ => {
		  	this.$refs.tree.setCheckedKeys([]);
			this.$refs.tree.setCheckedNodes([])
		  	done();
		    })
		    .catch(_ => {});
		
	  },
	  goSearch() {
		this.getSelects()
	  },
	  apply() {
		  let arr = []
		  this.chooseArrKeys.forEach(item=>{
			  if(item.toString().indexOf('-88')===-1) {
				  arr.push(item)
			  }
		  })
		  if (arr.length===0) {
			  this.$message.warning('还没有选中的接口');
			  return
		  }
		  this.$confirm('确定申请选中的接口吗',{type: 'warning'})
		    .then(_ => {
			// http://192.168.0.99:8023/order/interface/api/apply
			let params = {
				  orderId: this.orderId,
				  intfIds: arr
			  }
			orderApi.applyInterfaces(params)
			  .then((res) =>{
				  console.log(res)
				  if (res.state===200) {
					this.$refs.tree.setCheckedKeys([]);
					this.$refs.tree.setCheckedNodes([]);
					this.$message.success('申请成功');
					this.getSelects()
				  } else {
					this.$message.error(res.message);
				  }
				  
			  })
			  .catch(err=>{
				  this.$message.error(err);
			  })
		  	this.$refs.tree.setCheckedKeys([]);
		  	done();
		    })
		    .catch(_ => {});
	  },
	  handleEdit(index, row) {
		console.log(index, row);
		this.$router.push(`/apiTest?dimId=${row.dimId}&id=${row.intfId}`)
	  },
	  handleDelete(index, row) {
		this.$confirm('确定删除选中的接口吗',{type: 'warning'})
		  .then(_ => {
			  this.delApi(row.intfId)
			done();
		  })
		  .catch(_ => {});
	  },
	  delApi(arr) {
		let params = {
		  intfId: arr,
		  orderId: this.orderId
		}
		orderApi.deleteAppliedInterface(params)
		  .then((res) =>{
			  console.log(res)
			  if (res.state===200) {
				
			  } else {
				this.$message.error(res.message);
			  }
			  this.getTable()
			  // try{
			  // 	this.tableData = res.data.records
			  // }catch(e){
			  // 	//TODO handle the exception
			  // }
		  })
		  .catch(err=>{
			  this.$message.error(err);
		  })	
	  },
	  shenqing() {
		  this.applyApi = true
		  // this.getSelects()
	  },
	  resolveData(arr) {
		  let arrAll = []
		  arr.forEach(item => {
			  let obj = {}
			  let father_disabled = true
			  obj['id'] = item.dimId+'-88'
			  obj['label'] = item.dimName
			  let child = []
			  item.intfList.forEach(demo => {
				  if (demo.applied===0) {
					  father_disabled = false
				  }
				  child.push({id: demo.id,label: demo.name,disabled: demo.applied===1})
			  })
			  obj['disabled'] = father_disabled
			  obj['children'] = child
			  arrAll.push(obj)
		  })
		  console.log(arrAll)
		  this.treeData = arrAll
	  },
	  getSelects() {
		  if(!this.orderId) return
		  let params = {
		  	  orderId: this.orderId,
		  	  // pageNum: 1,
			  name: this.searchData
		    }
		  orderApi.getAppliedInterfaces(params)
		    .then((res) =>{
		  	  console.log(res)
		  	  if (res.state===200) {
		  		
		  	  } else {
		  		this.$message.error(res.message);
		  	  }
			  this.resolveData(res.data)
		    })
		    .catch(err=>{
		  	  this.$message.error(err);
		    })
		  
	  }
    },
    mounted(){
		this.$store.commit('setCenterIndex',2)
    }
}
</script>



// WEBPACK FOOTER //
// src/views/center/caseChild/case3.vue